function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "34qohz4g6a",
  d: "M0 6c0 3.314 2.686 6 6 6s6-2.686 6-6-2.686-6-6-6-6 2.686-6 6z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-965.000000, -288.000000) translate(965.000000, 288.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pdohokizpb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#34qohz4g6a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M-3.378 3.916L15.378 3.916 15.378 -0.252 -3.378 -0.252z",
  mask: "url(#pdohokizpb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DC0000",
  d: "M-3.378 8.084L15.378 8.084 15.378 3.916 -3.378 3.916z",
  mask: "url(#pdohokizpb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FECE00",
  d: "M-3.378 12.252L15.378 12.252 15.378 8.084 -3.378 8.084z",
  mask: "url(#pdohokizpb)"
}))));

function SvgGe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGe);
export default __webpack_public_path__ + "static/media/ge.16648367.svg";
export { ForwardRef as ReactComponent };